import AbsPosButton from './AbsPosButton';
import './AbsPosButton.css';

export default AbsPosButton;



// WEBPACK FOOTER //
// ./src/pages/Demo/components/AbsPosButton/index.js